import { useEffect, useState } from 'react';

export const useFakeProgress = (isDone: boolean, trigger?: string | number) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setProgress(0);

        if (isDone) {
            setProgress(100);
            return;
        }

        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 95) return prev;

                const increment =
                    prev < 60 ? 10 : prev < 80 ? 5 : prev < 90 ? 2 : 0.5;

                return Math.min(prev + increment, 95);
            });
        }, 400);

        return () => clearInterval(interval);
    }, [isDone, trigger]);

    return progress;
};
